import {
  UploadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  PlusOutlined,
  SearchOutlined,
  PrinterOutlined,
  FileOutlined,
  UserOutlined,
  FrownOutlined
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message,
  Upload,
  Modal,
  Select
} from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useRef, useState, useCallback } from 'react';
import { CSVLink } from 'react-csv';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Archive } from '../../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../../Images/FilterIcon.svg';
import { ReactComponent as ViewIcon } from '../../../Images/ViewIcon.svg';
import SalesOrderIcon from '../../../Images/sales-order.png';
import { deleteInquiry, fetchInquiryList, assignInquiry, assignFeasible, assignInquiryRegrettedReason } from '../../../slices/inquiry';
import { font } from '../../../Common/font';
import moment from 'moment';
import { fetchAndSetIpAddress } from '../../../slices/ipSlice';
import { resetUserList, fetchUserList } from '../../../slices/user';
import eventBus from '../../../utils/eventBus';

import { createActivityLog } from '../../../slices/activity-log';
import logo from '../../../Images/alux-logo.png';
const { Option } = Select;
const { TextArea } = Input;

const INQUIRY_STATUS_CHOICE = [
  "Pending",
  "Assigned",
  "Feasible",
  "Regretted",
  "Quotation",
  "SalesOrder",
];

function InquiryList() {
  let navigate = useNavigate();
  const csvRef = useRef();
  const { user: currentUser } = useSelector(state => state.auth);
  const userRole = currentUser?.role?.[0]?.name;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFeasibleModalVisible, setIsFeasibleModalVisible] = useState(false);
  const [isRegrattedModalVisible, setIsRegrattedModalVisible] = useState(false);
  const [description, setDescription] = useState('');
  const [fileList, setFileList] = useState([]);
  const [regrattedReason, setRegrattedReason] = useState('');
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const throttleTimer = useRef(null);
  const [search, setSearch] = useState(
    localStorage.getItem('inquiryList') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('inquiryList') || '',
  );
  const lastExecution = useRef(0);
  const dispatch = useDispatch();
  const { data = [], totalRecord, loading } = useSelector(state => state.inquiry);
  const { data: userList, status } = useSelector(state => state.user);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [AllcsvData, setAllCsvData] = useState([]);
  const [allPdfLoading, setAllPdfLoading] = useState(false);
  const [allCsvLoading, setAllCsvLoading] = useState(false);
  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'inquiry_number',
    'inquiry_date',
    'customer_name',
    'contact_person',
    'email',
    'mobile',
    'status',
    'assigned_user_details',
    'action',
  ]);

  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);


  const handleEdit = data => {
    navigate(`/edit-inquiry/${data.id}`);
  };
  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteInquiry(id))
      .unwrap()
      .then(() => {
        message.success('Inquiry Archive Successfully!');
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const showAssignModal = (record) => {
    dispatch(resetUserList());
    dispatch(fetchUserList({ page: 1, pagesize: 1000, superuser: false }));
    setSelectedInquiry(record);
    setSelectedUser(record.assigned_user_details !== null ? record.assigned_user_details : null);
    setIsModalVisible(true);
  };
  const handleUserChange = (value) => {
    const user = userList.find(u => u.id === value);
    setSelectedUser(user); // save full user object in state
  };

  const showRegrettedModal = (record) => {
    setSelectedInquiry(record);
    setIsRegrattedModalVisible(true);
  }

  const showFeasibleModal = (record) => {
    setSelectedInquiry(record);
    setIsFeasibleModalVisible(true);
  }

  const handleFeasibleSubmit = () => {
    if (!description.trim()) {
      message.error('Please enter a description');
      return;
    }


    // Prepare data to send
    const formData = new FormData();
    formData.append('feasible_description', description);
    if (fileList.length > 0) {
      fileList.forEach((file) => {
        if (file.originFileObj) {
          formData.append('feasible_attachment', file.originFileObj);
        }
      });
    }

    // Pass back to parent handler
    // onSubmit(formData);
    dispatch(assignFeasible({ id: selectedInquiry?.id, payload: formData }))
      .unwrap()
      .then(result => {

        if (result.success) {
          message.success(result?.message);
          setIsFeasibleModalVisible(false);
          // Reset after submit
          setDescription('');
          setFileList([]);
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });


  }
  const handleRegrattedSubmit = () => {
    if (!regrattedReason.trim()) {
      message.error('Please enter a regretted reason');
      return;
    }
    const values = {
      status: 'Regretted',
      regret_reason: regrattedReason
    }
    dispatch(assignInquiryRegrettedReason({ id: selectedInquiry?.id, payload: values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success(result?.message);
          setIsRegrattedModalVisible(false);
          setRegrattedReason('');
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
    // Close modal after saving

  };

  const handleAssign = () => {
    if (!selectedUser) {
      message.warning('Please select a user to assign');
      return;
    }


    dispatch(assignInquiry({ id: selectedInquiry?.id, payload: selectedUser?.id }))
      .unwrap()
      .then(({ message: msg }) => {
        msg && message.success(msg);
      })
      .catch(errMsg => {
        message.error(errMsg || 'An unknown error occurred.');
      })
      .finally(() => {
        setIsModalVisible(false);   // close no matter what
        setSelectedUser(null);      // optional reset
      });


  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedUser(null);
  };

  const handleFileChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const handleFeasibleCancel = () => {
    setDescription('');
    setFileList([]);
    setIsFeasibleModalVisible(false);
  }

  const handleRegrattedCancel = () => {
    setIsRegrattedModalVisible(false);
  }

  const handleStatusChange = (value, record) => {
    if (value === 'Assigned') {
      showAssignModal(record);
    }
    if (value === 'Regretted') {
      showRegrettedModal(record);
    }
    if (value === 'Feasible') {
      showFeasibleModal(record);
    }
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
      render: (text, record, index) => {
        return (page - 1) * pagesize + index + 1;
      },
    },
    {
      title: 'Inquiry ID',
      dataIndex: 'inquiry_number',
      key: 'inquiry_number',
      sorter: true
    },
    {
      title: 'Date',
      dataIndex: 'inquiry_date',
      key: 'inquiry_date',
      sorter: true,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY hh:mm A') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
    },
    {
      title: 'Contact Person',
      dataIndex: 'contact_persons',
      key: 'contact_person',
      render: (contact_persons) => {
        if (contact_persons && contact_persons.length > 0) {
          return contact_persons[0].name || 'N/A';
        }
        return 'N/A';
      },
    },
    {
      title: 'Email',
      dataIndex: 'contact_persons',
      key: 'email',
      render: (contact_persons) => {
        if (contact_persons && contact_persons.length > 0) {
          return contact_persons[0].email || 'N/A';
        }
        return 'N/A';
      },
    },
    {
      title: 'Mobile',
      dataIndex: 'contact_persons',
      key: 'mobile',
      render: (contact_persons) => {
        if (contact_persons && contact_persons.length > 0) {
          return contact_persons[0].mobile || 'N/A';
        }
        return 'N/A';
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => (
        <Select
          value={text}
          style={{ width: 150 }}
          onChange={(value) => handleStatusChange(value, record)}
        >
          {INQUIRY_STATUS_CHOICE.map((status) => (
            <Select.Option key={status} value={status}>
              {status}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    ...(userRole === 'Super Admin'
      ? [
        {
          title: 'Assigned To',
          dataIndex: 'assigned_user_details',
          key: 'assigned_user_details',
          render: record => (
            <span>{record?.first_name ? record.first_name : 'Not Assigned'}</span>
          ),
        },
      ]
      : []),
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 80,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: 80,
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 100,
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: 100,
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 130,
      render: (_, record) => (
        <Space size="small">
          {currentUser.permissions.permissions.inquiry.includes(
            'view_inquiry',
          ) && (
              <Tooltip placement="top" title={'View Inquiry'}>
                <Link to={`/view-inquiry/${record?.id}`}>
                  <ViewIcon />
                </Link>
              </Tooltip>
            )}
          {record?.status !== 'Quotation' && record?.status !== 'SalesOrder' && currentUser.permissions.permissions.inquiry.includes('change_inquiry') && (
            <Tooltip title="Convert to Quotation">
              <Link
                to={`/convert-inquiry-quotation/${record?.id}`}
                rel="noopener noreferrer"
              >
                <img src={SalesOrderIcon} alt="sales order" width="18" height="18" />
              </Link>
            </Tooltip>
          )}
          {/* <Tooltip placement="top" title={'Assign User'}>
            <span onClick={() => showAssignModal(record)}>
              <UserOutlined style={{ cursor: 'pointer' }} />
            </span>
          </Tooltip> */}
          {currentUser.permissions.permissions.inquiry.includes(
            'change_inquiry',
          ) && (
              <Tooltip placement="top" title={'Edit'}>
                <span onClick={() => handleEdit(record)}>
                  <EditIcon style={{ cursor: 'pointer' }} />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.inquiry.includes(
            'delete_inquiry',
          ) && (
              <Tooltip title="Archive">
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => handleDelete(record?.id)}
                  onCancel={() => message.info('Action cancelled')}
                  okText="Yes"
                  cancelText="No"
                >
                  <Archive style={{ cursor: 'pointer' }} />
                </Popconfirm>
              </Tooltip>
            )}
        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

const fetchInquiries = useCallback(() => {
    dispatch(
      fetchInquiryList({
        page,
        pagesize,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
    fetchInquiries();
  }, [fetchInquiries]);

   useEffect(() => {
    const handleReload = () => {
      fetchInquiries();
    };

    eventBus.on("financialYear:refresh", handleReload);

    return () => {
      eventBus.off("financialYear:refresh", handleReload);
    };
  }, [fetchInquiries]);

  const generateCsvListData = async () => {
    try {
      setAllCsvLoading(true);
      const response = await dispatch(
        fetchInquiryList({
          page: 1,
          pagesize: 5000,
        }),
      );

      const data = response?.payload?.results?.data || [];

      const rows = data.map((item, index) => {
        const row = {
          SrNo: (page - 1) * pagesize + index + 1,
        };

        allCsvColumns
          .filter(col => checkedList.includes(col.field))
          .forEach(col => {
            switch (col.field) {
              case 'SrNo':
                row.SrNo = index + 1;
                break;
              case 'customer_name':
                row.customerName = item?.customer_name || 'N/A';
                break;
              case 'factoryAddress':
                row.factoryAddress = [
                  item?.factory_address_shop || 'N/A',
                  item?.factory_address_area || 'N/A',
                  item?.factory_address_landmark || 'N/A',
                  item?.factory_address_city || 'N/A',
                  item?.factory_address_state || 'N/A',
                  item?.factory_address_pin_code || 'N/A',
                ]
                  .filter(text => text !== 'N/A')
                  .join(', ')
                  .toUpperCase();
                break;
              case 'officeAddress':
                row.officeAddress = [
                  item?.office_address_shop || 'N/A',
                  item?.office_address_area || 'N/A',
                  item?.office_address_landmark || 'N/A',
                  item?.office_address_city || 'N/A',
                  item?.office_address_state || 'N/A',
                  item?.office_address_pin_code || 'N/A',
                ]
                  .filter(text => text !== 'N/A')
                  .join(', ')
                  .toUpperCase();
                break;
              case 'phone_number':
                row.phoneNumber = item?.phone_number || 'N/A';
                break;
              case 'gstin_number':
                row.gstinNumber = item?.gstin_number || 'N/A';
                break;
              case 'pan_number':
                row.panNumber = item?.pan_number || 'N/A';
                break;
              case 'udyam_no':
                row.udyamNumber = item?.udyam_no || 'N/A';
                break;
              case 'gst_type':
                row.gstType = item?.gst_type || 'N/A';
                break;
              case 'created_at':
                row.createdAt = item.created_at
                  ? moment(item.created_at).format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'created_by':
                row.createdBy = item.created_by
                  ? `${item.created_by.first_name} ${item.created_by.last_name}`
                  : 'N/A';
                break;
              case 'updated_at':
                row.updatedAt = item.updated_at
                  ? moment(item.updated_at).format('DD-MM-YYYY')
                  : 'N/A';
                break;
              case 'updated_by':
                row.updatedBy = item.updated_by
                  ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
                  : 'N/A';
                break;
              case 'account_group':
                row.accountGroup = item?.account_group?.name || 'N/A';
                break;
              case 'customer_type':
                row.customerType = item?.customer_type?.name || 'N/A';
                break;
              case 'delivery_days':
                row.deliveryDays = item?.delivery_days || 'N/A';
                break;
              case 'applicable_gst':
                row.applicableGst = item?.applicable_gst || 'N/A';
                break;
              case 'customer_section_no':
                row.customerSectionNo = item?.customer_section_no || 'N/A';
                break;
              case 'bank_name':
                row.bankName = item?.bank_name || 'N/A';
                break;
              case 'bank_account_number':
                row.bankAccountNumber = item?.bank_account_number || 'N/A';
                break;
              case 'bank_ifsc_code':
                row.bankIfscCode = item?.bank_ifsc_code || 'N/A';
                break;
              case 'bank_branch_address':
                row.bankBranchAddress = item?.bank_branch_address || 'N/A';
                break;
              case 'email':
                row.email = item?.email || 'N/A';
                break;
              default:
                row[col.dataKey] = 'N/A';
            }
          });

        return row;
      });

      setAllCsvData(rows);
      setTimeout(() => {
        if (csvRef.current?.link) {
          csvRef.current.link.click();
        }
      }, 0);
    } catch (error) {
      console.error('CSV generation failed:', error);
    } finally {
      setAllCsvLoading(false);
    }
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const debounceTimeout = useRef(null);

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('inquiryList', value); // save to localStorage
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable

    localStorage.removeItem('inquiryList');
    dispatch(fetchInquiryList({ page: 1, pagesize }));
  };

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'inquiry_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'inquiry_number';
    }
    if (sortField === 'inquiry_number' && sortOrder === 'descend') {
      sortingEnumKey = '-inquiry_number';
    }
    if (sortField === 'inquiry_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'inquiry_date';
    }
    if (sortField === 'inquiry_date' && sortOrder === 'descend') {
      sortingEnumKey = '-inquiry_date';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    return sortingEnumKey;
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="inquiry_number">Inquiry Number</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="inquiry_date">Inquiry Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="contact_person">Contact Person</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="email">Email</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="mobile">Mobile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            {userRole === 'Super Admin' && (
              <Col xs={24} md={12}>
                <Checkbox value="assigned_user_details">Assigned To</Checkbox>
              </Col>
            )}
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const exportCustomerPDF = data => {
    const pdf = new jsPDF('p', 'pt', 'a4');
    pdf.addFileToVFS('WorkSans-normal.ttf', font);
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    pdf.setFont('WorkSans');

    const allColumns = [
      { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
      { header: 'Inquiry Number', dataKey: 'inquiry_number', field: 'inquiry_number' },
      { header: 'Inquiry Date', dataKey: 'inquiry_date', field: 'inquiry_date' },
      { header: 'Customer Name', dataKey: 'customerName', field: 'customer_name' },
      { header: 'Contact Person', dataKey: 'contact_person', field: 'contact_person' },
      { header: 'Email', dataKey: 'email', field: 'email' },
      { header: 'Mobile', dataKey: 'mobile', field: 'mobile' },
      { header: 'Assigned To', dataKey: 'assigned_user_details', field: 'assigned_user_details' },
      { header: 'Status', dataKey: 'status', field: 'status' },
      { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
      { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
      { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
      { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
    ];

    const columns = allColumns.filter(col => checkedList.includes(col.field));

    const rows = dataSource.map((item, index) => {
      const row = { SrNo: '1' };
      columns.forEach(col => {
        switch (col.field) {
          case 'SrNo':
            row.SrNo = (page - 1) * pagesize + index + 1;
            break;
          case 'inquiry_number':
            row.inquiry_number = item?.inquiry_number || 'N/A';
            break;
          case 'inquiry_date':
            row.inquiry_date = item?.inquiry_date
              ? moment(item.inquiry_date).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'customer_name':
            row.customerName = item?.customer_name || 'N/A';
            break;
          case 'contact_person':
            row.contact_person = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.name : 'N/A';
            break;
          case 'email':
            row.email = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.email : 'N/A';
            break;
          case 'mobile':
            row.mobile = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.mobile : 'N/A';
            break;
          case 'assigned_user_details':
            row.assigned_user_details = item?.assigned_user_details ? item.assigned_user_details?.first_name : 'N/A';
            break;
          case 'status':
            row.status = item?.status || 'N/A';
            break;
          case 'created_at':
            row.createdAt = item?.created_at
              ? moment(item.created_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'created_by':
            row.createdBy = item?.created_by
              ? `${item.created_by.first_name} ${item.created_by.last_name}`
              : 'N/A';
            break;
          case 'updated_at':
            row.updatedAt = item?.updated_at
              ? moment(item.updated_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'updated_by':
            row.updatedBy = item?.updated_by
              ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
              : 'N/A';
            break;
          default:
            row[col.dataKey] = item[col.field] || 'N/A';
            break;
        }
      });
      return row;
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.setFontSize(16);
    pdf.text('Inquiry', pageWidth / 2, 40, { align: 'center' });

    pdf.autoTable({
      columns,
      body: rows,
      startY: 80,
      theme: 'grid',
      margin: { top: 80, right: 15, left: 15, bottom: 40 },
      tableWidth: 'auto',
      styles: {
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 2,
        fontSize: 9,
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fillColor: false,
        halign: 'center',
      },
      columnStyles: {
        SrNo: { halign: 'center', cellWidth: 40 },
      },
      didDrawPage: data => {
        const pageCount = pdf.internal.getNumberOfPages();
        const currentPage = pdf.internal.getCurrentPageInfo().pageNumber;

        if (currentPage === 1) {
          pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
        }

        if (currentPage > 1) {
          data.settings.startY = 20; // reduces top offset before rendering next table part
          data.settings.margin.top = 20;
        }

        pdf.setFontSize(8);
        const dateTime = moment().format('DD-MM-YYYY HH:mm:ss');
        pdf.text(dateTime, 15, pageHeight - 10);
        pdf.text(`Page ${currentPage} of ${pageCount}`, pageWidth - 60, pageHeight - 10);
      },
    });

    pdf.save(`inquiry_${new Date().toISOString().split('T')[0]}.pdf`);

    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Inquiry',
        ip_address: ipAddress,
        discription: 'Inquiry pdf download successfully!',
      })
    );
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Customer',
        ip_address: ipAddress,
        discription: 'Customer excel download successfully!',
      }),
    );
  };
  const allCsvColumns = [
    { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
    { header: 'Inquiry Number', dataKey: 'inquiry_number', field: 'inquiry_number' },
    { header: 'Inquiry Date', dataKey: 'inquiry_date', field: 'inquiry_date' },
    { header: 'Customer Name', dataKey: 'customerName', field: 'customer_name' },
    { header: 'Contact Person', dataKey: 'contact_person', field: 'contact_person' },
    { header: 'Email', dataKey: 'email', field: 'email' },
    { header: 'Mobile', dataKey: 'mobile', field: 'mobile' },
    { header: 'Assigned To', dataKey: 'assigned_user_details', field: 'assigned_user_details' },
    { header: 'Status', dataKey: 'status', field: 'status' },
    { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
    { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
    { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
    { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
  ];

  const csvHeaders = allCsvColumns
    .filter(col => checkedList.includes(col.field)) // Filter only selected columns
    .map(col => ({
      label: col.header, // CSV column header
      key: col.dataKey, // Corresponding data key
    }));

  const csvListData = dataSource.map((item, index) => {
    const row = {
      SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    };
    allCsvColumns
      .filter(col => checkedList.includes(col.field))
      .forEach(col => {
        switch (col.field) {
          case 'SrNo':
            row.SrNo = index + 1; // Ensuring Sr No. is correctly assigned
            break;
          case 'inquiry_number':
            row.inquiry_number = item?.inquiry_number || 'N/A';
            break;
          case 'inquiry_date':
            row.inquiry_date = item?.inquiry_date
              ? moment(item.inquiry_date).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'customer_name':
            row.customerName = item?.customer_name || 'N/A';
            break;
          case 'contact_person':
            row.contact_person = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.name : 'N/A';
            break;
          case 'email':
            row.email = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.email : 'N/A';
            break;
          case 'mobile':
            row.mobile = item?.contact_persons && item?.contact_persons.length > 0 ? item.contact_persons[0]?.mobile : 'N/A';
            break;
          case 'assigned_user_details':
            row.assigned_user_details = item?.assigned_user_details ? item.assigned_user_details?.first_name : 'N/A';
            break;
          case 'status':
            row.status = item?.status || 'N/A';
            break;
          case 'created_at':
            row.createdAt = item?.created_at
              ? moment(item.created_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'created_by':
            row.createdBy = item?.created_by
              ? `${item.created_by.first_name} ${item.created_by.last_name}`
              : 'N/A';
            break;
          case 'updated_at':
            row.updatedAt = item?.updated_at
              ? moment(item.updated_at).format('DD-MM-YYYY')
              : 'N/A';
            break;
          case 'updated_by':
            row.updatedBy = item?.updated_by
              ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
              : 'N/A';
            break;
          default:
            row[col.dataKey] = item[col.field] || 'N/A';
            break;
        }
      });
    return row;
  });
  const Allcsvheaders = allCsvColumns.map(col => ({
    label: col.header,
    key: col.dataKey,
  }));

  const handleAllPdfDownload = async () => {
    setAllPdfLoading(true);
    try {
      const response = await dispatch(
        fetchInquiryList({
          page,
          pagesize: 5000, // explicitly setting it
        }),
      );
      const pdf = new jsPDF('l', 'pt', 'a4');
      pdf.addFileToVFS('WorkSans-normal.ttf', font);
      pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
      pdf.setFont('WorkSans');
      const allColumns = [
        { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
        {
          header: 'Customer Name',
          dataKey: 'customerName',
          field: 'customer_name',
        },
        { header: 'Email', dataKey: 'email', field: 'email' },
        { header: 'GSTIN Number', dataKey: 'gstinNumber', field: 'gstin_number' },
        { header: 'GST Type', dataKey: 'gstType', field: 'gst_type' },
        { header: 'PAN Number', dataKey: 'panNumber', field: 'pan_number' },
        { header: 'Udyam Number', dataKey: 'udyamNumber', field: 'udyam_no' },
        {
          header: 'Account Group',
          dataKey: 'accountGroup',
          field: 'account_group',
        },
        {
          header: 'Customer Type',
          dataKey: 'customerType',
          field: 'customer_type',
        },
        {
          header: 'Delivery Days',
          dataKey: 'deliveryDays',
          field: 'delivery_days',
        },
        {
          header: 'Applicable GST',
          dataKey: 'applicableGst',
          field: 'applicable_gst',
        },
        {
          header: 'Customer Profile No.',
          dataKey: 'customerSectionNo',
          field: 'customer_section_no',
        },
        {
          header: 'Factory Address',
          dataKey: 'factoryAddress',
          field: 'factoryAddress',
        },
        {
          header: 'Office Address',
          dataKey: 'officeAddress',
          field: 'officeAddress',
        },
        { header: 'Phone Number', dataKey: 'phoneNumber', field: 'phone_number' },
        { header: 'Created At', dataKey: 'createdAt', field: 'created_at' },
        { header: 'Created By', dataKey: 'createdBy', field: 'created_by' },
        { header: 'Updated At', dataKey: 'updatedAt', field: 'updated_at' },
        { header: 'Updated By', dataKey: 'updatedBy', field: 'updated_by' },
      ];
      const columns = allColumns.filter(col => checkedList.includes(col.field));
      const rows = response?.payload?.results?.data.map((item, index) => {
        const row = {
          SrNo: index + 1, // Assigning sequential serial numbers
        };
        columns.forEach(col => {
          switch (col.field) {
            case 'sr_no':
              row.SrNo = index + 1; // Ensuring Sr No. is correctly assigned
              break;
            case 'customer_name':
              row.customerName = item.customer_name || 'N/A';
              break;
            case 'factoryAddress':
              row.factoryAddress = [
                item?.factory_address_shop || 'N/A',
                item?.factory_address_area || 'N/A',
                item?.factory_address_landmark || 'N/A',
                item?.factory_address_city || 'N/A',
                item?.factory_address_state || 'N/A',
                item?.factory_address_pin_code || 'N/A',
              ]
                .filter(text => text !== 'N/A')
                .join(', ')
                .toUpperCase();
              break;
            case 'officeAddress':
              row.officeAddress = [
                item?.office_address_shop || 'N/A',
                item?.office_address_area || 'N/A',
                item?.office_address_landmark || 'N/A',
                item?.office_address_city || 'N/A',
                item?.office_address_state || 'N/A',
                item?.office_address_pin_code || 'N/A',
              ]
                .filter(text => text !== 'N/A')
                .join(', ')
                .toUpperCase();
              break;
            case 'office_address':
              row.officeAddress = item.office_address || 'N/A';
              break;
            case 'phone_number':
              row.phoneNumber = item.phone_number || 'N/A';
              break;
            case 'gstin_number':
              row.gstinNumber = item.gstin_number || 'N/A';
              break;
            case 'pan_number':
              row.panNumber = item.pan_number || 'N/A';
              break;
            case 'udyam_no':
              row.udyamNumber = item.udyam_no || 'N/A';
              break;
            case 'gst_type':
              row.gstType = item.gst_type || 'N/A';
              break;
            case 'created_at':
              row.createdAt = item.created_at
                ? moment(item.created_at).format('DD-MM-YYYY')
                : 'N/A';
              break;
            case 'created_by':
              row.createdBy = item.created_by
                ? `${item.created_by.first_name} ${item.created_by.last_name}`
                : 'N/A';
              break;
            case 'updated_at':
              row.updatedAt = item.updated_at
                ? moment(item.updated_at).format('DD-MM-YYYY')
                : 'N/A';
              break;
            case 'updated_by':
              row.updatedBy = item.created_by
                ? `${item.created_by.first_name} ${item.created_by.last_name}`
                : 'N/A';
              break;
            case 'under_group':
              row.underGroup = item.under_group.name || 'N/A';
              break;
            case 'account_group':
              row.accountGroup = item.account_group.name || 'N/A';
              break;
            case 'customer_type':
              row.customerType = item.customer_type.name || 'N/A';
              break;
            case 'delivery_days':
              row.deliveryDays = item.delivery_days || 'N/A';
              break;
            case 'applicable_gst':
              row.applicableGst = item.applicable_gst || 'N/A';
              break;
            case 'customer_section_no':
              row.customerSectionNo = item.customer_section_no || 'N/A';
              break;
            case 'bank_name':
              row.bankName = item.bank_name || 'N/A';
              break;
            case 'bank_account_number':
              row.bankAccountNumber = item.bank_account_number || 'N/A';
              break;
            case 'bank_ifsc_code':
              row.bankIfscCode = item.bank_ifsc_code || 'N/A';
              break;
            case 'bank_branch_address':
              row.bankBranchAddress = item.bank_branch_address || 'N/A';
              break;
            case 'email':
              row.email = item.email || 'N/A';
              break;
            default:
              break;
          }
        });
        return row;
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      pdf.setFontSize(16);
      pdf.text('Customer', pageWidth / 2, 40, { align: 'center' });
      const totalWidth = pdf.internal.pageSize.getWidth() - 30; // Adjusted for margins
      const columnWidth = totalWidth / columns.length; // Equal width for each column
      pdf.autoTable({
        columns,
        body: rows,
        startY: 80,
        theme: 'grid',
        margin: { top: 80, right: 15, left: 15, bottom: 40 },
        tableWidth: 'auto',
        styles: {
          halign: 'center',
          overflow: 'linebreak',
          cellPadding: 2,
          fontSize: 9,
          lineWidth: 0.4,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [0, 0, 0],
          fillColor: false,
        },
        columnStyles: columns.reduce((acc, col) => {
          acc[col.dataKey] = { cellWidth: columnWidth }; // Set fixed equal width for all columns
          return acc;
        }, {}),
        didDrawPage: data => {
          pdf.setFontSize(8);
          const pageCount = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            pdf.setPage(i);
            pdf.text(
              `Page ${i} of ${pageCount}`,
              pdf.internal.pageSize.getWidth() - 50,
              pdf.internal.pageSize.getHeight() - 10,
            );
          }
        },
      });
      pdf.save(`customer${new Date().toISOString().split('T')[0]}.pdf`);
    } catch (error) {
      console.error('PDF generation failed:', error);
    } finally {
      setAllPdfLoading(false);
    }
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };


  return (
    <div className='mainwrap'>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Inquiry</h2>
              <div className="bredcrumbwrp">
                <Link
                  className="back"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Inquiry' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className="searchbox"
                  prefix={<SearchOutlined />}
                  value={inputValue}
                  style={{ width: 190 }}
                  onChange={handleSearch}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>

                {currentUser.permissions.permissions?.inquiry.includes(
                  'add_inquiry',
                ) && (
                    <Tooltip title="Add Inquiry">
                      <Link to="/add-inquiry">
                        <Button type="primary" icon={<PlusOutlined />}>
                          Add Inquiry
                        </Button>
                      </Link>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.inquiry.includes(
                  'delete_inquiry',
                ) && (
                    <Link to="/archive-inquiry-list" className="iconlink">
                      <Tooltip title="Archive">
                        <Archiveicon />
                      </Tooltip>
                    </Link>
                  )}
                {currentUser.permissions.permissions.inquiry.includes(
                  'download_inquiry_pdf_copy',
                ) && (
                    <Tooltip placement="top" title={'Export PDF'}>
                      <Button
                        type="primary"
                        onClick={exportCustomerPDF}
                        icon={<FilePdfOutlined />}
                      >
                      </Button>
                    </Tooltip>
                  )}
                {currentUser.permissions.permissions.inquiry.includes(
                  'download_inquiry_excel_copy',
                ) && (
                    <Tooltip placement="top" title={'Export Excel'}>
                      <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        onClick={activityLog}
                      >
                        <CSVLink
                          filename={'inquiry.csv'}
                          data={csvListData}
                          headers={csvHeaders}
                        >
                        </CSVLink>
                      </Button>
                    </Tooltip>
                  )}
                <div className="gridiconswrap">
                  <Tooltip placement="topLeft" title="Column Filter Options">
                    <Dropdown
                      overlay={columnMenu}
                      trigger={['click']}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Button
                        type="primary"
                        icon={<ColumnList />}
                        onClick={e => e.preventDefault()}
                      />
                    </Dropdown>
                  </Tooltip>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>


      <div className='tablewrp'>
        <Table
          rowKey="id"
          columns={filteredColumns}
          dataSource={data}
          pagination={false} // Disable built-in pagination
          loading={loading}
          onChange={handleTableChange}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['10', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />

      <Modal
        title={
          <div className="flex items-center gap-2">
            <UserOutlined className="text-blue-500" />
            <span>Assign User to Inquiry</span>
          </div>
        }
        open={isModalVisible}
        onOk={handleAssign}
        onCancel={handleCancel}
        width={500}
        okText="Assign"
        cancelText="Cancel"
        okButtonProps={{ className: 'bg-blue-500 hover:bg-blue-600' }}
      >
        <div className="py-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Select User to Assign <span className="text-red-500">*</span>
            </label>
            <Select
              size="large"
              placeholder="Choose a user"
              style={{ width: '100%' }}
              value={selectedUser?.id}
              onChange={handleUserChange}
              showSearch
              optionFilterProp="children"
            >
              {userList?.map(user => (
                <Option key={user.id} value={user.id}>
                  <div className="flex items-center justify-between">
                    <span>{user.first_name} {user.last_name}</span>
                    <span className="text-xs text-gray-500">{user?.groups.join(', ')}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </div>

          {selectedUser && (
            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
              <div className="flex items-center gap-2 text-sm text-blue-700">
                <UserOutlined />
                <span>
                  <strong>{selectedInquiry?.inquiry_number}</strong> will be assigned to <strong>{selectedUser?.first_name} {selectedUser?.last_name}</strong>
                </span>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        title={
          <div className="flex items-center gap-2">
            <FileOutlined className="text-red-500" />
            <span>Feasible Study</span>
          </div>
        }
        open={isFeasibleModalVisible}
        onOk={handleFeasibleSubmit}
        onCancel={handleFeasibleCancel}
        width={500}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{ className: 'bg-blue-500 hover:bg-blue-600' }}
      >
        <div className="py-4 space-y-4">
          {/* Description Field */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Description <span className="text-red-500">*</span>
            </label>
            <TextArea
              rows={4}
              placeholder="Enter details of the feasible study"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {/* File Upload Field */}
          <div className='mt-4'>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Attach File
            </label>

            <Upload
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleFileChange}
              multiple
              accept=".pdf,.jpg,.jpeg,.png,.dwg,.dxf,.step,.iges,.stl"
              maxCount={5}
              className="upload-drawing-file"
            >
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>

            <p className="text-xs text-gray-500 mt-2">
              Upload PDF, Images, CAD files (DWG, DXF, STEP, IGES, STL, etc.)
            </p>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div className="flex items-center gap-2">
            <FrownOutlined className="text-red-500" />
            <span>Regretted For Reason</span>
          </div>
        }
        open={isRegrattedModalVisible}
        onOk={handleRegrattedSubmit}
        onCancel={handleRegrattedCancel}
        width={500}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{ className: 'bg-blue-500 hover:bg-blue-600' }}
      >
        <div className="py-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Regretted Reason <span className="text-red-500">*</span>
            </label>
            <TextArea
              rows={4}
              placeholder="Enter the reason for regretting this inquiry"
              value={regrattedReason}
              onChange={(e) => setRegrattedReason(e.target.value)}
            />

          </div>
        </div>
      </Modal>

    </div>
  );
}

export default InquiryList;
